import { render, staticRenderFns } from "./simple-message-modal.vue?vue&type=template&id=48d96091&"
import script from "./simple-message-modal.vue?vue&type=script&lang=js&"
export * from "./simple-message-modal.vue?vue&type=script&lang=js&"
import style0 from "./simple-message-modal.vue?vue&type=style&index=0&id=48d96091&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports